"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.G = exports.Use = exports.TSpan = exports.TextPath = exports.Text = exports.Symbol = exports.Svg = exports.Stop = exports.Rect = exports.RadialGradient = exports.Polyline = exports.Polygon = exports.Path = exports.LinearGradient = exports.Line = exports.Image = exports.Ellipse = exports.Defs = exports.ClipPath = exports.Circle = void 0;
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
var react_native_svg_1 = require("react-native-svg");
var platform_1 = require("./platform");
var createElement = function (type) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            return React.createElement(type, this.props, this.props.children);
        };
        return class_1;
    }(React.Component));
};
var convertProps = function (props) {
    var transforms = [];
    if (props.translateX || props.translateY) {
        var x = lodash_1.default.get(props, 'translateX', 0);
        var y = lodash_1.default.get(props, 'translateY', 0);
        transforms.push("translate(" + x + ", " + y + ")");
    }
    if (props.originX || props.originY) {
        var x = lodash_1.default.get(props, 'originX', 0);
        var y = lodash_1.default.get(props, 'originY', 0);
        transforms.push("origin(" + x + ", " + y + ")");
    }
    if (props.scaleX || props.scaleY) {
        var x = lodash_1.default.get(props, 'scaleX', 0);
        var y = lodash_1.default.get(props, 'scaleY', 0);
        transforms.push("scale(" + x + ", " + y + ")");
    }
    if (props.rotateX || props.rotateY) {
        var x = lodash_1.default.get(props, 'rotateX', 0);
        var y = lodash_1.default.get(props, 'rotateY', 0);
        transforms.push("rotate(" + x + ", " + y + ")");
    }
    if (props.skewX || props.skewY) {
        var x = lodash_1.default.get(props, 'skewX', 0);
        var y = lodash_1.default.get(props, 'skewY', 0);
        transforms.push("skew(" + x + ", " + y + ")");
    }
    if (props.scale) {
        transforms.push("scale(" + props.scale + ")");
    }
    if (props.origin) {
        transforms.push("origin(" + props.origin + ")");
    }
    if (props.translate) {
        transforms.push("translate(" + props.translate + ")");
    }
    /*if (props.onPress) {
      transforms.push(`onclick(${props.onPress})`);
    }*/
    if (transforms.length === 0) {
        return props;
    }
    return __assign(__assign({}, lodash_1.default.omit(props, [
        'scaleX',
        'scaleY',
        'scale',
        'translateX',
        'translateY',
        'translate',
        'skewX',
        'skewY',
        'skew',
        'originX',
        'originY',
        'origin',
        'onPress',
    ])), { transform: transforms.join(' ') });
};
var convertGradientProps = function (props) {
    var newProps = lodash_clonedeep_1.default(props);
    if (props.stopColor) {
        newProps['stop-color'] = props.stopColor;
    }
    if (props.stopOpacity) {
        newProps['stop-opacity'] = props.stopOpacity;
    }
    return newProps;
};
var createGroup = function () {
    return /** @class */ (function (_super) {
        __extends(class_2, _super);
        function class_2() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_2.prototype.render = function () {
            return React.createElement('g', convertProps(this.props), this.props.children);
        };
        return class_2;
    }(React.Component));
};
var createGradient = function (name) {
    return /** @class */ (function (_super) {
        __extends(class_3, _super);
        function class_3() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_3.prototype.render = function () {
            return React.createElement(name, convertGradientProps(this.props), this.props.children);
        };
        return class_3;
    }(React.Component));
};
exports.default = createElement('svg');
exports.Circle = createElement('circle');
exports.ClipPath = createElement('clipPath');
exports.Defs = createElement('defs');
exports.Ellipse = createElement('ellipse');
exports.Image = createElement('image');
exports.Line = createElement('line');
exports.LinearGradient = createGradient('linearGradient');
exports.Path = createElement('path');
exports.Polygon = createElement('polygon');
exports.Polyline = createElement('polyline');
exports.RadialGradient = createGradient('radialGradient');
exports.Rect = createElement('rect');
exports.Stop = createElement('stop');
exports.Svg = createElement('svg');
exports.Symbol = createElement('symbol');
exports.Text = createElement('text');
exports.TextPath = createElement('textPath');
exports.TSpan = createElement('tspan');
exports.Use = createElement('use');
var G = function (props) { return platform_1.isWeb ? React.createElement("g", __assign({}, convertProps(props))) : React.createElement(react_native_svg_1.G, __assign({}, props)); };
exports.G = G;
